import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  loading: false,
  tags: [],
  error: "",
  selectedTags: [],
};

export const getTags = createAsyncThunk("tag/getTags", async (_, thunkApi) => {
  const { rejectedWithValue } = thunkApi;
  try {
    const res = await axios.get(
      "product/api/v1/products/tags/?page_size=1000000",
    );
    const data = res.data.results.map((tag) => ({
      id: tag.id,
      name: tag.title,
    }));
    return data;
  } catch (err) {
    return rejectedWithValue(err);
  }
});

const TagSlice = createSlice({
  name: "tag",
  initialState: initialState,
  reducers: {
    setSelectedTags(state, action) {
      state.selectedTags = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTags.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getTags.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.tags = action.payload;
    });
    builder.addCase(getTags.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { setSelectedTags } = TagSlice.actions;
export default TagSlice.reducer;
